import React from "react";

const ProfileIcon = () => {
	return (
		<>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="18"
				height="17"
				viewBox="0 0 18 17"
				fill="none"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9.0004 8.5C11.0714 8.5 12.75 6.82064 12.75 4.74961C12.75 2.67858 11.0714 1 9.0004 1C6.92938 1 5.25002 2.67858 5.25002 4.74961C5.24303 6.81365 6.91073 8.49301 8.97398 8.5H9.0004Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9.0004 11.5C5.7639 11.5 3 11.948 3 13.742C3 15.536 5.74636 16 9.0004 16C12.2369 16 15 15.5513 15 13.758C15 11.9647 12.2544 11.5 9.0004 11.5Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</>
	);
};
export default ProfileIcon;
